import { render, staticRenderFns } from "./ClinicalQualityManagement.vue?vue&type=template&id=11e6b07a&"
import script from "./ClinicalQualityManagement.vue?vue&type=script&lang=js&"
export * from "./ClinicalQualityManagement.vue?vue&type=script&lang=js&"
import style0 from "./ClinicalQualityManagement.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports